import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RatingModule } from 'primeng/rating';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SkeletonModule } from 'primeng/skeleton';
import { PanelModule } from 'primeng/panel';
import { CarouselModule } from 'primeng/carousel';
import { PasswordModule } from "primeng/password";
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({

  imports: [
    TableModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule, 
    ToastModule,
    ButtonModule,
    CalendarModule,
    DialogModule,
    ConfirmDialogModule,
    RatingModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule ,
    InputTextareaModule,
    ProgressBarModule, 
    TooltipModule,
    RadioButtonModule, 
    ToolbarModule,
    FileUploadModule,
    TabViewModule,
    ToggleButtonModule,
    SkeletonModule,
    PanelModule,
    CarouselModule,
    PasswordModule,
    MessagesModule,
    MessageModule,
    ProgressSpinnerModule
    ],
  exports: [
    TableModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    ToastModule,
    ButtonModule,
    CalendarModule,
    DialogModule,
    ConfirmDialogModule,
    RatingModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    InputTextareaModule,
    ProgressBarModule,
    TooltipModule,
    RadioButtonModule,
    ToolbarModule,
    FileUploadModule,
    TabViewModule,
    ToggleButtonModule,
    SkeletonModule,
    PanelModule,
    CarouselModule,
    PasswordModule,
    MessagesModule,
    MessageModule,
    ProgressSpinnerModule
  ],

})
export class NgPrimeModule { }


/**  Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
